import 'jquery/dist/jquery.min.js'
import 'popper.js/dist/popper.min'
import 'bootstrap/dist/js/bootstrap.min.js'
import "./src/assets/bootstrap.css"
import "./src/assets/style.scss"
// import "./src/assets/style-rtl.css"
import "./src/assets/print.css"
import "./src/assets/style-theme.css"
